// src/App.js
import React, { useState } from 'react';
//import CoordinatesMap from './components/CoordinatesMap';
import DistanceMap from './components/DistanceMap';
//import DraggableMarkersMap from './components/DraggableMarkersMap';
import './leafletIcons.js';
import './App.css'

//function App() {
//  const [currentMap, setCurrentMap] = useState('coordinates');
//
//  return (
//    <div>
//      <h1>Leaflet Map Functionalities</h1>
//      <div style={{ marginBottom: '1rem' }}>
//        <button onClick={() => setCurrentMap('coordinates')}>Get Coordinates</button>
//        <button onClick={() => setCurrentMap('distance')}>Distance Between Points</button>
//        <button onClick={() => setCurrentMap('draggable')}>Draggable Markers</button>
//      </div>
//      <div>
//        {currentMap === 'coordinates' && <CoordinatesMap />}
//        {currentMap === 'distance' && <DistanceMap />}
//        {currentMap === 'draggable' && <DraggableMarkersMap />}
//      </div>
//    </div>
//  );
//}

function App() {
  return (
    <div>
      <h1>Distance Measurement Map</h1>
      <DistanceMap />
    </div>
  );
}

export default App;
